import React from "react";

const Home1 = () => {
  return (
    <section className="home1-section" id="home1">
      <div className="home1-content">
        <h2 className="home1-title">
          Die Plattform für <span className="highlight"> projektbasierte </span> <span className="highlight">Zusammenarbeit&nbsp;</span> 
           zwischen hochqualifizierten Talenten und zukunftsorientierten Unternehmen.
        </h2>
        <img
          src="/assets/handshakeblue.png"
          alt="Zusammenarbeit"
          className="home1-image"
        />
      </div>
    </section>
  );
};

export default Home1;
